
import '../css/Worklist.css';
import React, {  useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbarweb from "../component/Navbar";
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import {encryptData,decryptData} from "../component/EncryptACCESSION_NO";
import Snackbar from '@mui/material/Snackbar';
import axios from 'axios';
//icon
import Searchicon from "../img/searchicon.png";
import Cancelicon from "../img/cancelicon.png";
//detailboximage
import Stsapproved from "../img/sts-approved.png";
import Stsarrived from "../img/sts-arrived.png";
import Stsarriving from "../img/sts-arriving.png";
import Stscancel from "../img/sts-cancel.png";
import Stsscheduled from "../img/sts-schedule.png";
import Stsexamined from "../img/pacs-img.png";
import Tele from "../img/tele.png";
import Pacsyes from "../img/pacs-yes.png";
import Pacsno from "../img/pacs-no.png";
import Reportimg from "../img/report.png";
import Notebut from "../img/notebut.png";
import Ipserver from '../../src/ipserver'
import { useParams } from "react-router-dom";
import MuiAlert from '@mui/material/Alert';
import { useLogin } from '../component/LoginContext';
import IpPacs from '../ipPacs';

function Worklist() {
    const { user, pwd , passCode , isLoggedIn } = useLogin();
    const navigate = useNavigate();
    const [selectedStatus, setSelectedStatus] = useState("Scheduling");
    const [selectedWait, setSelectedWait] = useState("10");
    const { hn } = useParams(); // ดึงค่า accession จาก URL ถ้ามี
    const ip = Ipserver;
    const [data, setData] = useState([]);
    // For search query
    const [ accession,setAccession ] = useState('');
    const [showModals, setShowModals] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [foundNote,setFoundNote] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('Saved!');
    const [reportData , setReportData] = useState('');
    const [showReportModal,setShowReportModal] = useState(false);
    const [patientID,setPatientId] = useState('');
    //MBT_NOTE
    //NOTE_TEXT
    const [noteText,setNoteText] = useState('');
    //TABLE_NAME
    const [tableName,setTableName] = useState('');
    //STUDY_KEY
    const [noteStudyKey,setNoteStudyKey] = useState('');

    //IF FOUND DATA IN MBT_NOTE THIS WILL HAVE NOTE_KEY TO SEARCH FOR UPDATE.
    //NOTE_KEY
    const [noteKey,setNoteKey] = useState('');

    const [snackbarerr , setSnackbarerr] = useState('success');


    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });


    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway' ) {
            return;
        }
        setSnackbarOpen(false); 
        setSnackbarerr('success')
    };
    const handleModalShow = async (key , tablename) => {
        
        try {
            console.log('Get Note AccessNo : ',key);
            console.log('Get Note Table Name : ',tablename);
            const response = await axios.get(`https://${Ipserver}/api/GetNote`, {
                params: {
                    search: key,
                    tablename:tablename
                }
            });
            console.log(response.data);
            const data = response.data;
            if(data.length > 0){
                setNoteText(data[0].NOTE_TEXT);
                setNoteKey(data[0].NOTE_KEY);
                setFoundNote(true);
                console.log('Found Note.');
            }
            else{
                setFoundNote(false);
                console.log('Note not found.');
            }
            setShowModals(true);
        } catch (err) {
            console.error('Error to search:', err);
        }
    
        
    };
    
    const handleModalClose = () => {
        setShowReportModal(false);
        setShowModals(false);
        setReportData('');
        setNoteText('');
        setTableName('');
        setNoteKey('');
        setNoteStudyKey('');
    };

    const handleModalSave = async() => {
        
        if(foundNote){
            console.log(noteKey);
            console.log(noteStudyKey);
            console.log(tableName);
            console.log(user?.name);
            console.log(noteText);
            try{
                await axios.put(`https://${Ipserver}/api/UpdateNote`,{
                    NOTE_KEY:noteKey,
                    STUDY_KEY:noteStudyKey,
                    TABLE_NAME:tableName,
                    USER_ID:user?.name,
                    NOTE_TEXT:noteText
                })

                setSnackbarOpen(true)
            }
            catch (err){
                console.error('Error updating note:', err);
                setSnackbarOpen(true); // แจ้งว่ามีข้อผิดพลาด
                setSnackbarMessage('Error updating note!'); 
            }
            
        }
        else{
            try{
                console.log(noteStudyKey);
                console.log(tableName);
                console.log(user.name);
                console.log(noteText);
                const response = await axios.post(`https://${Ipserver}/api/AddNote`,{
                    STUDY_KEY:noteStudyKey,
                    TABLE_NAME:tableName,
                    USER_ID:user?.name,
                    NOTE_TEXT:noteText
                })
                setNoteKey(response.data.noteKey);
                setSnackbarOpen(true);
                setFoundNote(true);
            }
            catch (err) {
                console.error('Error for create data to mbt_note : ', err);
                setSnackbarOpen(true); // แจ้งว่ามีข้อผิดพลาด
                setSnackbarMessage('Error creating note!'); 
            }
        }
    };


    const handleTableName = (tablename) => {
        setTableName(tablename)
    }

    const handleNoteChange = (e) => {
        
        setNoteText(e.target.value)
    };
    const handleNavigate = (patientData,tableName) => {
        console.log('patiendData : ',patientData);
        console.log('tableName : ',tableName)
        const patient = 'Acc='+patientData+'&Table=' + tableName;
        console.log(patient);
        const patientdata = encryptData(patient) ;
        console.log(patientdata)
        console.log('Decrypt Data : ',decryptData(patientdata));
        
        navigate(`/Teleinfo/${patientdata}`);
    };

    
    useEffect(() => {
        setPatientId(hn);
      }, [hn]);
    
    const handleSearch = async () => {
        try {
            let response;

            if (accession.trim()) {
                response = await axios.get(`https://${Ipserver}/api/SearchAccession/`, {
                    params: {
                        accession: accession
                    }
                });
            } else {
                response = await axios.get(`https://${Ipserver}/api/worklist/${passCode.passCode}`);
            }

            const data = response.data;
            setData(data);

        } catch (err) {
            console.error('Error to search:', err);
            setSnackbarMessage('Error searching data');
            setSnackbarOpen(true);
            setSnackbarerr('error');
        }
    };



    

    useEffect(() => {
        const fetchData = async () => {
            try {
                let apiURL = `https://${ip}/api/worklist/${passCode.passCode}`; // ค่า default
                
                if (hn) {
                    apiURL = `https://${ip}/api/worklist/${passCode.passCode}/${hn}`;
                    
                }

                const response = await fetch(apiURL);
                const result = await response.json();
                setData(result);
                if (hn) setAccession(result[0].ACCESS_NO);
                
            } catch (err) {
                console.error('Error fetching data: ', err);
            }
        };

        fetchData(); 
    }, [hn, ip ]); 

    const imageSts = (sts) =>{
        let imageSrc;
        let status;
        if(sts == '0') {
            imageSrc =  Stscancel;    
            status = 'Canceled';
        }
        else if (sts == '110') {
            imageSrc = Stsscheduled;
            status = 'Scheduled';
        }
        
        else if (sts == '115') {
            imageSrc = Stsarriving;
            status = 'Arriving';
        }
        
        else if (sts == '120') {
            imageSrc = Stsarrived;
            status = 'Arrived';
        }
        
        else if (sts == '200') {
            imageSrc = Stsexamined;
            status = 'Examined';
        }
        
        else if (sts == '240') {
            imageSrc = Stsapproved;
            status = 'Approved';
        }
        
        else if (sts == '201') {
            imageSrc = '';
            status = 'NonDicom';
        }

        else {
            imageSrc = '';
            status = '';
        }
        
        return {imageSrc,status};
    }

    const calculateAge = (date) => {
        if (date) {
            const birthDate = new Date(date.split('T')[0]);
    
            const today = new Date();
            let ageYears = today.getFullYear() - birthDate.getFullYear();
            let ageMonths = today.getMonth() - birthDate.getMonth();
        
            if (ageMonths < 0 || (ageMonths === 0 && today.getDate() < birthDate.getDate())) {
                ageYears--;
                ageMonths += 12; 
            }
        
            if (today.getDate() < birthDate.getDate()) {
                ageMonths--;
            }
        
            return `${ageYears}Y ${ageMonths}M`;
        }
        else {
            return '';
        }
    
        
    };



    const OpenPacs = (status , accession , patientID) => {
        
        const ippacs = IpPacs;
        if(isLoggedIn){
            if(status >= 200){
                window.open(`http://${ippacs}/pkg_pacs/external_interface.aspx?TYPE=V&LID=${user?.name}&LPW=${pwd?.pass}&AN=${accession}`)
                
                
            } else {
                window.open(`http://${ippacs}/pkg_pacs/external_interface.aspx?TYPE=V&LID=${user?.name}&LPW=${pwd?.pass}&AN=${patientID}`)
                
            }
        }
        else {
            setSnackbarMessage('Please Login');
            setSnackbarOpen(true); // เปิด Snackbar
            setSnackbarerr('error')
        }
        
    }
    const SubDate = (date) => {
        // แปลง string เป็น Date object
        const originalDate = new Date(date);

        // ดึงข้อมูลวัน เดือน และ ปี
        const day = String(originalDate.getDate()).padStart(2, '0');
        const month = String(originalDate.getMonth() + 1).padStart(2, '0'); // เดือนเริ่มที่ 0 ต้องบวก 1
        const year = originalDate.getFullYear();

        // ดึงข้อมูลเวลา ชั่วโมง นาที วินาที
        const hours = String(originalDate.getHours()).padStart(2, '0');
        const minutes = String(originalDate.getMinutes()).padStart(2, '0');
        const seconds = String(originalDate.getSeconds()).padStart(2, '0');

        // จัดรูปแบบเป็น DD-MM-YYYY HH:mm:ss
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    }

    const OpenReport = async(data) => {
        const response = await axios.get(`https://${Ipserver}/api/GetReport`,{
            params:{
                accession:data
            }
        });
        setShowReportModal(true);
        setReportData(response.data);
    }

    const handleCancle = async () => {
        // Clear the accession state
        setAccession('');
        
        try {
            // Fetch all worklist data
            const response = await axios.get(`https://${Ipserver}/api/worklist/${passCode.passCode}`);
            setData(response.data);
        } catch (err) {
            console.error('Error fetching worklist data:', err);
            setSnackbarMessage('Error fetching data');
            setSnackbarOpen(true);
            setSnackbarerr('error');
        }
    };

    const handleSearchInputChange = (e) => {
        setAccession(e.target.value);
    };

    const tablebodyfunc = () => {
        return data.map((d, i) => {
            const status = imageSts(d.STUDY_STAT); // คำนวณ imageSrc จาก STUDY_STAT
            const imageSrc = status.imageSrc;
            const altImage = status.status;
            return (
                <tr key={i}>
                    {/* stsstatus */}
                    <th >
                        {imageSrc ? 
                            <img className='boxicon' src={imageSrc} alt={altImage} title={altImage}/>:null
                        }
    
                    </th>
    
                    {/* pacsstatus */}
                    {
                    (d.STUDY_STAT >= 200 && d.TABLE_NAME === 'STUDY') ? 
                        <th>
                            <a 
                                href='#'
                                onClick={(e) => { e.preventDefault(); OpenPacs(d.STUDY_STAT, d.ACCESS_NO, d.PATIENT_ID); }}
                                aria-label="Open PACS Study"
                            >
                                <img className='boxicon' src={Pacsyes} alt='pasno'/>
                            </a>
                        </th>
                    :
                        <th>
                            <img className='boxicon' src={Pacsno} alt='pasno'/>
                        </th>
                    }
                    
    
                    {/* tele */}
                    <th>
                        <a href='#' onClick={(e) => { e.preventDefault(); handleNavigate(d.ACCESS_NO,d.TABLE_NAME); }}>
                            <img className='boxicon' src={Tele} alt='tele'/> 
                        </a>
                    </th>
    
                    {/* report */}
                    <th>
                        {(d.STUDY_STAT >= 240 && d.TABLE_NAME === 'STUDY') ?
                            <a  href='#' onClick={(e) => {e.preventDefault();OpenReport(d.ACCESS_NO)}}>
                                <img className='boxicon' src={Reportimg} alt='report' />
                            </a>
                        :
                            <></>
                        }
                    </th>
    
                    {/* note */}
                    <th>
                        <a href='#' onClick={(e) => {e.preventDefault();handleModalShow(d.ACCESS_NO,d.TABLE_NAME);handleTableName(d.TABLE_NAME);setNoteStudyKey(d.STUDY_KEY);}}>
                            {d.NOTE_STATUS == 'HaveNote' ? 
                             <img className='boxicon ' src={Notebut} alt='note'/> 
                            :
                             <img className='boxicon graybut' src={Notebut} alt='note'/>}
                            
                        </a>
                    </th>
    
                    {/* id */}
                    <th>
                        <p>{d.PATIENT_ID}</p>
                    </th>
    
                    {/* name */}
                    <th><p>{d.PATIENT_NAME}</p></th>
    
                    {/* sex */}
                    <th>
                        <p className={d.PATIENT_SEX === 'M' ? 'psexM' : 'psexF'}>•{d.PATIENT_SEX}</p>
                    </th>
    
                    {/* age */}
                    <th><p>{calculateAge(d.PATIENT_BIRTH_DTTM)}</p></th>
    
                    {/* request date */}
                    <th><p>{SubDate(d.REQUEST_DTTM)}</p></th>
    
                    {/* exam description */}
                    <th><p>{d.STUDY_DESC}</p></th>
    
                    {/* STATUS */}
                    <th><p>{d.STUDY_STAT}</p></th>
    
                    {/* REFERRING PHYSICIAN */}
                    <th><p>{d.REQUEST_DOCTOR}</p></th>
    
                    {/* ACCESSION# */}
                    <th><p>{d.ACCESS_NO}</p></th>
    
                    {/* STUDY REASON */}
                    <th><p>{d.STUDY_REASON}</p></th>
    
                    {/* DEPARTMENT */}
                    <th><p>{d.DEPARTMENT}</p></th>
                </tr>
            );
        });
    };
    


    return (
        <div >
            <Modal show={showModals}  onHide={handleModalClose} centered>
                <Modal.Header>
                    <h1 className='text-center'>Note</h1>
                    <Button 
                        variant="close" 
                        onClick={handleModalClose} 
                    />
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className='mt-2'>
                        <Form.Label >Note Detail</Form.Label>
                        <Form.Control id='notevalue' value={noteText || ''} as="textarea" rows={15} onChange={handleNoteChange}></Form.Control>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer className='modalbutt'>
                    <Button onClick={handleModalClose} className='button btn-danger me-3'>Cancel</Button>
                    <Button onClick={handleModalSave} className='button btn-primary'>Save</Button>
                </Modal.Footer>
            </Modal>

            
            <Modal 
                show={showReportModal}  
                onHide={handleModalClose} 
                centered 
                dialogClassName="custom-modal"
            >
                <Modal.Header className="d-flex justify-content-between align-items-center"> {/* เปลี่ยนเป็น justify-content-between */}
                    <h1 className='m-0'>Report</h1> {/* ใช้ m-0 เพื่อลบ margin */}
                    <Button 
                        variant="close" 
                        onClick={handleModalClose} 
                    />
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className='mt-2'>
                        <Form.Control 
                            readOnly  
                            id='reportValue' 
                            value={reportData || ''} 
                            as="textarea" 
                            rows={15} 
                        />
                    </Form.Group>
                </Modal.Body>
            </Modal>

            <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={handleSnackbarClose}>
                <Alert onClose={handleSnackbarClose} severity = {snackbarerr}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>


            <Navbarweb />
            
            <Card className='mt-2 cardworklist'>
                <Card.Body>
                    <Row className='cardmg'>
                        {/* From date Box */}
                        <Col md={3}>
                            <Row><p className='ms-1 inputtext'>From Date</p></Row>
                            <Row className='sizebox'>
                                <Form.Control disabled  className=' ms-1 ' type="date" id="fromdate"/>
                            </Row>
                        </Col>

                        {/* To date Box */}
                        <Col md={3}>
                            <Row><p className='ms-1 inputtext'>To Date</p></Row>
                            <Row className='sizebox'>
                                <Form.Control disabled className=' ms-1' type="date" id="todate"/>
                            </Row>
                        </Col>

                        {/* Status Box */}
                        <Col md={3}>
                            <Row><p className='ms-1 inputtext'>Status</p></Row>
                            <Row className='sizebox'>
                                <Form.Select
                                    disabled
                                    aria-label="statusbox"
                                    value = {selectedStatus}
                                    onChange={(e) => setSelectedStatus(e.target.value)}>
                                    <option value="Canceled">Canceled</option>
                                    <option value="Scheduling">Scheduling</option>
                                    <option value="Arriving">Arriving</option>
                                    <option value="Arrived">Arrived</option>
                                    <option value="Examined">Examined</option>
                                    <option value="Transcribed">Transcribed</option>
                                    <option value="Approved">Approved</option>
                                    <option value="AddendumApproved">Addendum Approved</option>
                                </Form.Select>
                            </Row>
                        </Col>

                        {/* Wait Box */}
                        <Col md={3}>
                            <Row><p className='ms-1 inputtext'>Wait Than (Min)</p></Row>
                            <Row className='sizebox'>
                                <Form.Select aria-label="waitbox"
                                    disabled
                                    value={selectedWait}
                                    onChange={(e) => setSelectedWait(e.target.value)}>
                                    <option value="10">10</option>
                                    <option value="15">15</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                </Form.Select>
                            </Row>
                        </Col>
                    </Row>

                    
                    <Row className='cardmg mt-3 mb-3'>
                        {/* First Name Box */}
                        <Col md={3}>
                            <Row><p className='ms-1 inputtext'>Name</p></Row>
                            <Row className='sizebox'>
                                <Form.Control disabled className=' ms-1 ' placeholder='Enter patient name' id="firstname"/>
                            </Row>
                        </Col>

                        {/* Last Name Box */}
                        <Col md={3}>
                            <Row><p className='ms-1 inputtext'>Accession No</p></Row>
                            <Row className='sizebox'>
                                <Form.Control 

                                    className='ms-1'
                                    value={accession || ''}
                                    onChange={handleSearchInputChange}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSearch();
                                        }
                                    }}
                                    placeholder='Enter patient Accession No'
                                    id="accession_no"
                                />
                            </Row>
                        </Col>

                        {/* Patient ID */}
                        <Col md={3}>
                            <Row><p className='ms-1 inputtext'>Patient ID</p></Row>
                            <Row className='sizebox'>
                                <Form.Control value={patientID || ''} disabled className=' ms-1 ' placeholder='MDS1234'  id="patientid"/>
                            </Row>
                        </Col>
                        <Col md={3}>
                            <Row><p className='ms-1 inputtext'>Patient ID Card</p></Row>
                            <Row className='sizebox'>
                                <Form.Control disabled className=' ms-1 ' placeholder='0-1234-56789-10-1'  id="patientidcard"/>
                            </Row>
                        </Col>
                    </Row>
                    {/* Button */}
                    <div className='btnworklist'>
                        <Button className='button btnsearch me-3' onClick={handleSearch} variant="light" id='Searchbutton'>
                            <img className='buttonicon me-1' src={Searchicon} alt='searchicon'/>Search
                        </Button>
                        <Button className='button btncancel me-3' onClick={handleCancle} variant="danger" id='Cancelbutton'>
                            <img className='buttonicon me-1' src={Cancelicon} alt='cancelicon'/>Cancel
                        </Button>
                    </div>
                    <hr/>


                    {/* Detail Box */}
                    <div className='mt-3 table-container table-body'>
                        <Table striped >
                            <thead className = 'worklisttable'>
                                <tr className='text-center table-head '>
                                    <th className='headerbox'>STS</th>
                                    <th className='headerbox'>PACS</th>
                                    <th className='headerbox'>TELE</th>
                                    <th className='headerbox'>REPORT</th>
                                    <th className='headerbox'>NOTE</th>
                                    <th className='headerbox'>ID</th>
                                    <th className='headerbox'>NAME</th>
                                    <th className='headerbox'>SEX</th>
                                    <th className='headerbox'>AGE</th>
                                    <th className='headerbox'>REQUEST DATE</th>
                                    <th className='headerbox'>EXAM DESCRIPTION</th>
                                    <th className='headerbox'>STATUS</th>
                                    <th className='headerbox'>REFERRING PHYSICIAN</th>
                                    <th className='headerbox'>ACCESSION#</th>
                                    <th className='headerbox'>STUDY REASON</th>
                                    <th className='headerbox'>DEPARTMENT</th>
                                </tr>
                            </thead>
                            <tbody >
                                {tablebodyfunc()}
                            </tbody>
                        </Table>
                    </div>
                    
                </Card.Body>
            </Card>
        </div>

           
    );
}

export default Worklist;